import { V1SearchAssetsResponse } from '@blk/portfolio-security-server/asset';



export const mapSecuritySearchResponseToSecurityList = (response: V1SearchAssetsResponse) => {
	const securitySearchResponse = { assets: [] as Array<any>, searchResultCount: 0 };
	if (response.assets?.length) {
		securitySearchResponse.assets = response.assets;
		securitySearchResponse.searchResultCount = response.searchResultCount || 0;
	}
	return securitySearchResponse;
};


export const mapSecuritySearchResponseToFacetFieldsList = (response: V1SearchAssetsResponse) => {
	return response.facetFields ?? [];
};
